import * as Cookies from 'tiny-cookie';
import defaultGroups from "./defaultGroups";
import defaultMakePropertyPrefix from "./defaultMakePropertyPrefix";
export var defaultCookiePrefix = 'n3__wcag';
export var baseSetCookie = function baseSetCookie(cookiePrefix, makePropertyPrefix, property, value) {
  var propertyPrefix = makePropertyPrefix(cookiePrefix, property);
  Cookies.set(propertyPrefix, value);
};
export var defaultSetCookie = function defaultSetCookie(property, value) {
  baseSetCookie(defaultCookiePrefix, defaultMakePropertyPrefix, property, value);
};
export var baseGetSettings = function baseGetSettings(cookiePrefix, makePropertyPrefix, groups) {
  return groups.reduce(function (res, _ref) {
    var property = _ref.property,
        initial = _ref.initial;
    var propertyPrefix = makePropertyPrefix(cookiePrefix, property);
    var value = Cookies.get(propertyPrefix);
    res[property] = value || initial;
    return res;
  }, {});
};
export var defaultGetSettings = function defaultGetSettings() {
  return baseGetSettings(defaultCookiePrefix, defaultMakePropertyPrefix, defaultGroups);
};